// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"326":"website","593":"miniProgram"}[chunkId] + "." + {"326":"316c2897","593":"500a19f3"}[chunkId] + ".js";
};